export default {
    buildHTML(klass){
        return "<div class='skeleton-screen-container'><div class='skeleton-body-"+klass+" mb-2'></div></div>"
    }
}